import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckDates } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';

import { TCMDefaultDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_DATES } from '@constants/queryKeys';

interface IUseConsistencyCheckDatesReturnType {
	dates: number[];
	isLoadingDates: boolean;
}

type TUseConsistencyCheckDates = Partial<TCMDefaultDTO>

const useQueryConsistencyCheckDates = (params: TUseConsistencyCheckDates): IUseConsistencyCheckDatesReturnType => {
	const {
		vendor,
		technology,
		nodeType,
	} = params;

	const {
		data: dates,
		isLoading: isLoadingDates,
		isFetching: isFetchingDateOptions,
	} = useQuery<number[]>({
		queryKey: [CONSISTENCY_DATES, params],
		queryFn: extractQueryParams(getConsistencyCheckDates),
		enabled: [
			!!vendor,
			!!technology,
			!!nodeType,
		],
		...refetchOptions,
	});

	return {
		dates: dates || [],
		isLoadingDates: (isLoadingDates && !!dates)
			|| isFetchingDateOptions,
	};
};

export default useQueryConsistencyCheckDates;
